import { number, string, object } from 'yup';

export const readingIdStepSchema = object({
  readingId: string()
    .required('required')
    .test({
      message: 'invalid',
      test: value => !!value && /^\d{9}$/.test(value.toString()),
    }),
  houseNumber: number().required(),
});
